
import XEndpoints from "../../core/config/Endpoints";
import XApi from "../../utils/api";

export class ConfigService {
    async update(id, data) {
        const token = localStorage.getItem('token');
        if (token) {
            const response = await XApi.patch(`${XEndpoints.config}/${id}`, data, {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            });
            return response ?? null;
        }
        return null;
    }
}